import { ROUTE_LOADING_SCREEN } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './loading-screen.page';

export const routeLoadingScreen: RouteObject = {
  path: ROUTE_LOADING_SCREEN,
  Component: Page,
  loader: setTitleFromLoader('Loading Screen'),
};
